import { http, notification } from '../../services/index'
import { apiPaths } from '../../config'
import { factorySetStateAction } from '../factory'
// Defined Device Constants to bind SAGA functions with Redux Dispatcher
const actions = {
  SET_STATE: 'member/SET_STATE',
  GET_MEMBERS: 'member/GET_MEMBERS',
  ADD_NEW_MEMBER: 'member/ADD_NEW_MEMBER',
  UPDATE_MEMBER: 'member/UPDATE_MEMBER',
  ASSIGN_FACILITIES: 'member/ASSIGN_FACILITIES',
  GET_MEMBER_DETAIL: 'member/GET_MEMBER_DETAIL',
  SET_STATUS: 'member/SET_STATUS',
  DELETE_MEMBER: 'member/DELETE_MEMBER',
  GET_ACM_APIS: 'member/GET_ACM_APIS',
  GET_PROVIDER_PROFILE: 'member/GET_PROVIDER_PROFILE',
  GET_USER_DETAIL: 'member/GET_USER_DETAIL',
  GET_USER_LOGIN_HISTORY: 'member/GET_USER_LOGIN_HISTORY',
  GET_USER_LIST: 'member/GET_USER_LIST',
  GET_USER_CLINICS: 'GET_USER_CLINICS',
  UPDATE_USER_CLINICS: 'UPDATE_USER_CLINICS',
  UPDATE_USER_CLINICS_PCC_MEMBERS: 'UPDATE_USER_CLINICS_PCC_MEMBERS',
  RESET_PASSWORD: 'member/RESET_PASSWORD',
  GET_PCC_MEMBERS: 'member/GET_PCC_MEMBERS',
  ASSIGN_FACILITIES_PCC_MEMBERS: 'member/ASSIGN_FACILITIES_PCC_MEMBERS',
}

export const memberSetState = factorySetStateAction(actions.SET_STATE)

// API call to get Details of a specific Member
export const getMemberDetail = (userUID) =>
  // YQ: define api into config (apiPaths)
  http
    .get(`/virtualclinic-temp/v1/memberDetail`, { user_uid: userUID }, {})
    .then((res) => res)
    .catch((err) => {
      const { response } = err
      notification.error(
        `Something went wrong`,
        `${response && response.data ? response.data : err}`,
      )
      return {}
    })

// API call to get a List of all the members assigned to a provider or all the members in case of Super Admin
export const getAllMembers = (dataObj, role) =>
  http
    .get(apiPaths[role] ? apiPaths[role].apiMemberListing : '', dataObj, {})
    .then((res) => ({ data: res }))
    .catch((err) => {
      const { response } = err
      const { status } = response
      notification.error(
        `${status === 404 ? 'Not Found' : 'Something went wrong'}`,
        `${response && response.data ? response.data : err}`,
      )
      return {
        err: `${response && response.data ? response.data : err}`,
        data: [],
      }
    })

// API call to get a List of all the shared Members
export const getSharedMembers = (dataObj, role) =>
  http
    .get(apiPaths[role] ? apiPaths[role].apiSharedMemberListing : '', dataObj, {})
    .then((res) => ({ data: res }))
    .catch((err) => {
      const { response } = err
      window.log('err', response, err)

      return { err, data: [] }
    })

// API call to get the sum of all Sleep Sesssions done by all the Members registered under the logged In Provider, or All Members in case of SuperAdmin.
export const getTotalSleepSessions = (dataObj, role) =>
  http
    .get(apiPaths[role] ? apiPaths[role].apiGetTotalSleepSessions : '', dataObj, {})
    .then((res) => (res[0] ? res[0].sleep_count : '-'))
    .catch((err) => {
      const { response } = err
      notification.error(
        `Something went wrong`,
        `${response && response.data ? response.data : err}`,
      )
      return '-'
    })

// API call to get a List of all the Active Members registered under the logged in Provider.
export const getAllActiveMembers = (dataObj, role) =>
  http
    .get(apiPaths[role] ? apiPaths[role].apiActiveMemberListing : '', dataObj, {})
    .then((res) => ({ data: res }))
    .catch((err) => ({ err, data: [] }))

// API call to get a List of API's
export const getACMAPI = () =>
  // YQ: need to get from config apiPath
  http
    .get('/sa-acm/v1/getAllApis')
    .then((res) => res)
    .catch((err) => {
      const { response } = err
      notification.error(
        `Something went wrong`,
        `${response && response.data ? response.data : err}`,
      )
      return []
    })

// API call to get a List of API's the Specified role is authorized to access.
export const getAccess = (group) =>
  // YQ: need to get from config apiPath
  http
    .get('/sa-acm/v1/getAllApisOfRole', { group }, {})
    .then((res) => res)
    .catch((err) => {
      const { response } = err
      notification.error(
        `Something went wrong`,
        `${response && response.data ? response.data : err}`,
      )
      return []
    })

export const getUserList = (payload = {}) => ({
  type: actions.GET_USER_LIST,
  payload,
})

export const getUserDetail = (payload) => ({
  type: actions.GET_USER_DETAIL,
  payload,
})

export const getUserLoginHistory = (payload) => ({
  type: actions.GET_USER_LOGIN_HISTORY,
  payload,
})

export const addNewMember = (payload) => ({
  type: actions.ADD_NEW_MEMBER,
  payload,
})

export const updateMember = (payload) => ({
  type: actions.UPDATE_MEMBER,
  payload,
})

export const setStatus = (payload) => ({
  type: actions.SET_STATUS,
  payload,
})

export const deleteMember = (payload) => ({
  type: actions.DELETE_MEMBER,
  payload,
})

export const getUserClinics = (payload) => ({
  type: actions.GET_USER_CLINICS,
  payload,
})

export const updateUserClinics = (payload) => ({
  type: actions.UPDATE_USER_CLINICS,
  payload,
})

export const updateUserClinicsPccMembers = (payload) => ({
  type: actions.UPDATE_USER_CLINICS_PCC_MEMBERS,
  payload,
})

export const assignFacilities = (payload) => ({
  type: actions.ASSIGN_FACILITIES,
  payload,
})

export const assignFacilitiesPccMembers = (payload) => ({
  type: actions.ASSIGN_FACILITIES_PCC_MEMBERS,
  payload,
})

export const resetUserPassword = (payload) => ({
  type: actions.RESET_PASSWORD,
  payload,
})

export const getPccMembers = (payload) => ({
  type: actions.GET_PCC_MEMBERS,
  payload,
})

export default actions
